/**
 * This file should store all the paths whose pages do not contain subsections such as (dev docs, dashboard).
 * In case we need a main sections with multiple paths (dictionaries, contracts, wallets), please create a new path file
 * to save all related paths into the same location.
 */

export const SINGLE_NAVIGATION_PATHS = {
    DEFAULT_PATH: '/',
    LIFEGRAPH: '/lifegraph',
    ABOUT_APP_VERSION: '/about',
    HELP_DESK: '/help-desk',
    SYSTEM_MESSAGES: '/system-messages',
    ASK_BLAST: '/ask-blast',
    DASHBOARD: '/dashboard',
    // USER_PROFILE: '/profile', We are keeping the profile path and permissions for now.
    METADATA_SEARCH: '/metadata-search',
    NOT_FOUND_ERROR: 'NotFoundError',
    INSUFFICIENT_PERMISSION_ERROR: 'InsufficientPermissionsError',
    EXPORT: '/export',
    TQL_EDITOR: '/tql-editor',
    SETTINGS: '/settings',
};
